// Badge/tag primitif — DESIGN-GUIDE section 3 (rounded-full) + couleurs fonctionnelles.
// tone : neutral | primary | green | danger | info

const TONES = {
  neutral: 'bg-card border border-card-border text-ink/70',
  primary: 'bg-primary/10 text-primary',
  green: 'bg-green/10 text-green',
  danger: 'bg-red-500/10 text-red-500',
  info: 'bg-blue-500/10 text-blue-600',
}

export default function Badge({ tone = 'neutral', className = '', children, ...props }) {
  const toneCls = TONES[tone] || TONES.neutral
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full ${toneCls} ${className}`.trim()}
      {...props}
    >
      {children}
    </span>
  )
}
